import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Account, CustomerBaseData, UserDataModel } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable, tap } from 'rxjs';
import { AuthStateFacade } from '../auth/auth-state.facade';

@Injectable({ providedIn: 'root' })
export class CustomerInfrastructure {
  private _endpoint = environment.apihost;

  constructor(
    private _http: HttpClient,
    private _authStateFacade: AuthStateFacade,
  ) {}

  public getCustomerBaseData(): Observable<CustomerBaseData> {
    return this._http.get<CustomerBaseData>(`${this._endpoint}/api/user/base/${this._authStateFacade.customerId}`).pipe(
      tap((data) => {
        data.depotId = this.removeK(data.depotId);
      }),
    );
  }

  public getAccountData(): Observable<UserDataModel> {
    return this._http.get<UserDataModel>(`${this._endpoint}/api/user/contactdata`);
  }

  public getCustomerAccount(): Observable<Account> {
    return this._http.get<Account>(`${this._endpoint}/api/moneytransaction/account/?customerId=${this._authStateFacade.customerId}`);
  }

  public removeK(depotId: string) {
    return depotId?.startsWith('K') ? depotId.substring(1) : depotId;
  }
}
